import { HttpParams } from '@angular/common/http';

export class DepositoPixFilter {

  empresaId: string;
  licencaId: string;
  rangeDates: Date[];
  historico: string;
  status: string;
  statusOptions: any[];
  tpPeriodoOptions: any[];
  tpPeriodo: string;

  constructor(empresaId: string) {
    this.empresaId = empresaId;
    this.status = 'ATIVO';
    this.tpPeriodo = 'E';

    this.statusOptions = [
      { label: 'ATIVO', value: 'ATIVO' },
      { label: 'PAGO', value: 'PAGO' },
      { label: 'EXPIRADO', value: 'EXPIRADO' },
      { label: 'TODOS', value: undefined }
    ];

    this.tpPeriodoOptions = [
      { label: 'Emissão', value: 'E' },
      { label: 'Pagamento', value: 'P' }
    ];
  }

  clear() {
    this.historico = undefined;
    this.rangeDates = undefined;
  }

  initRangeDates() {
    const startDate = new Date(new Date().setDate(new Date().getDate()));
    this.rangeDates = [];
    this.rangeDates.push(startDate);
    this.rangeDates.push(null);
  }

  getSearchParams() {
    let params = new HttpParams();

    if (this.empresaId !== undefined) {
      params = params.set('empresaId', this.empresaId);
    }

    if (this.licencaId !== undefined) {
      params = params.set('licencaId', this.licencaId);
    }

    if (this.rangeDates !== undefined && this.rangeDates[0] != null) {
      const dtStr = this.rangeDates[0].toISOString().substring(0, 10);
      if (this.tpPeriodo === 'E') {
        params = params.set('dtInicio', dtStr);
      } else if (this.tpPeriodo === 'P') {
        params = params.set('dtPagtoInicio', dtStr);
      }
    }

    if (this.rangeDates !== undefined && this.rangeDates[1] != null) {
      const dtStr = this.rangeDates[1].toISOString().substring(0, 10);
      if (this.tpPeriodo === 'E') {
        params = params.set('dtFim', dtStr);
      } else if (this.tpPeriodo === 'P') {
        params = params.set('dtPagtoFim', dtStr);
      }
    }

    if (this.historico !== undefined && this.historico !== undefined) {
      params = params.set('historico', this.historico);
    }

    if (this.status !== undefined && this.status !== null) {
      params = params.set('status', this.status);
    }

    return params;
  }

}
